var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDescriptionDash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 13.2167H9.75V11.9167H3.25V13.2167ZM3.25 9.75H9.75V8.45H3.25V9.75ZM1.56672 16.4667C1.12891 16.4667 0.758333 16.315 0.455 16.0117C0.151667 15.7083 0 15.3378 0 14.9V1.56672C0 1.12891 0.151667 0.758333 0.455 0.455C0.758333 0.151667 1.12891 0 1.56672 0H8.45L13 4.55V14.9C13 15.3378 12.8483 15.7083 12.545 16.0117C12.2417 16.315 11.8711 16.4667 11.4333 16.4667H1.56672ZM7.8 5.2V1.3H1.56672C1.49998 1.3 1.43888 1.32781 1.38342 1.38342C1.32781 1.43888 1.3 1.49998 1.3 1.56672V14.9C1.3 14.9667 1.32781 15.0278 1.38342 15.0833C1.43888 15.1389 1.49998 15.1667 1.56672 15.1667H11.4333C11.5 15.1667 11.5611 15.1389 11.6166 15.0833C11.6722 15.0278 11.7 14.9667 11.7 14.9V5.2H7.8Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionDash);
export default __webpack_public_path__ + "static/media/description_dash.44b93405aed8869249c4205295879533.svg";
export { ForwardRef as ReactComponent };